export class DateType {
  public static Hijri = 1;
  public static Gregorian  = 2;
}
